export const HEAT_SELECT = 'HEAT_SELECT';

export const heatSelect = (heat) => ({
    type: HEAT_SELECT,
    payload: heat
});



// WEBPACK FOOTER //
// ./src/store/actions/heat.js